<template>
    <el-row>
       <div id="breadcrumb" style="display: block;">
        <el-breadcrumb separator="/" class="admincrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>营销</el-breadcrumb-item>
          <el-breadcrumb-item>COUPON</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div id="toolbar" style="display: block; text-align: right;">
        <el-form :inline="true" :model="sData" name="squery" ref="squery" size="small" class="form-inline">
          <el-form-item label="搜索条件">
            <el-input v-model="sData.tabName" required placeholder="请输入搜索关键词"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button type="primary"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>搜索优惠券</el-button>
              <el-button type="primary" @click="addBoxShow = true"><i class="fa fa-plus" style="font-weight: bolder; margin-right: 6px;"></i>新增优惠券</el-button>
            </el-button-group>
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="addBoxShow">
          <el-form :model="addData" name="addForm" ref="addForm">
            <el-form-item label="优惠券" prop="coupon" :rules="{required: true, message: '请设定您的优惠券', trigger: 'blur'}">
              <el-input  v-model="addData.coupon" placeholder="请设定您的优惠券"></el-input>
            </el-form-item>
            <el-form-item label="优惠模式" prop="calc" :rules="{required: true, message: '优惠模式不能为空', trigger: 'blur'}">
              <el-radio-group v-model="addData.calc">
                <el-radio label="*">百分比</el-radio>
                <el-radio label="-">固定优惠值</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="优惠值" prop="price" :rules="{required: true, message: '优惠值不能为空', trigger: 'blur'}">
              <el-input-number v-model="addData.price" placeholder="请设定您的优惠值"></el-input-number>
            </el-form-item>
            <el-form-item label="发券数量" prop="count" :rules="{required: false, message: '优惠券个数不能为空', trigger: 'blur'}">
              <el-input-number v-model="addData.count" placeholder="请设定您的优惠券个数"></el-input-number>
            </el-form-item>
            <el-form-item label="开始时间" prop="startAt" :rules="{required: true, message: '广告开始时间不能为空', trigger: 'blur'}">
              <el-date-picker v-model="addData.startAt" type="datetime" placeholder="选择开始日期时间" :change="getStart" align="right" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endAt" :rules="{required: false, message: '广告结束时间不能为空', trigger: 'blur'}">
              <el-date-picker v-model="addData.endAt" type="datetime" placeholder="选择结束日期时间" :change="getEnd" align="right" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="优惠券说明" prop="explain" :rules="{required: true, message: '优惠券说明不能为空', trigger: 'blur'}">
              <el-input type="textarea" :rows="5" v-model="addData.explain" placeholder="请输入优惠券说明"></el-input>
            </el-form-item>
            <el-form-item label="优惠券类型" prop="couponType_id" :rules="{required: true, message: '优惠券类型', trigger: 'blur'}">
              <el-radio-group v-model="addData.couponType_id">
                <el-radio v-for="cptype in couponType" :key="cptype.ID" :label="cptype.ID" @change="typeChange">{{ cptype.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="currType === 'spu' || currType === 'sku'" label="绑定SKU" prop="spus" :rules="{required: true, message: '优惠券产品绑定', trigger: 'blur'}">
              <el-input type="textarea" :rows="5" v-model="addData.spus" placeholder="绑定优惠券产品SPU，多个产品使用英文逗号分隔"></el-input>
            </el-form-item>
            <el-form-item label="是否一次性使用" prop="once" :rules="{required: true, message: '是否一次性使用', trigger: 'blur'}">
              <el-radio-group v-model="addData.once">
                <el-radio label="t">是</el-radio>
                <el-radio label="f">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item style="text-align: right;">
              <el-button type="primary" @click="handleNewCoupon('addForm')"><i class="fa fa-plus-circle"></i>新增优惠券</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <div id="bodycontainer">
        <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="cpList" stripe>
            <el-table-column prop="ID" label="ID"></el-table-column>
            <el-table-column prop="groupType.name" label="优惠券类型"></el-table-column>
            <el-table-column prop="coupon" label="优惠券"></el-table-column>
            <el-table-column prop="calc" label="优惠类型">
              <template slot-scope="scop">
                <span v-if="scop.row.calc === '-'">固定优惠</span>
                <span v-else>百分比</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="优惠价值"></el-table-column>
            <el-table-column prop="once" label="一次性券">
              <template slot-scope="scop">
                <span v-if="scop.row.once">一次性券</span>
                <span v-else>循环券</span>
              </template>
            </el-table-column>
            <el-table-column prop="isGlobal" label="全店优惠">
               <template slot-scope="scop">
                <span v-if="scop.row.isGlobal">全店优惠</span>
                <span v-else>产品优惠</span>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="发行数量"></el-table-column>
            <el-table-column fixed="right" label="操作" width="250">
              <template slot-scope="scop">
                <el-button-group>
                  <el-button type="text">编辑</el-button>
                  <el-button type="text">产品</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div id="pagination">
          <el-pagination
            @current-change="loadCoupon"
            :current-page="cpPage.page"
            :page-sizes="[15]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="cpPage.total">
          </el-pagination>
        </div>
    </el-row>
</template>

<script>
export default {
  name: 'Coupon',
  data () {
    return {
      sData: {},
      load: '',
      pageloading: false,
      cpPage: {page: 1, 'total': 0},
      cpList: [],
      couponType: [],
      addBoxShow: false,
      addData: {startAt: '', endAt: ''},
      cpTypeRoute: {},
      currType: ''
    }
  },
  mounted () {
    this.loadCoupon(1)
    this.loadCouponType()
  },
  methods: {
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    loadCoupon: function (page) {
      var that = this
      this.$set(that.cpPage, 'page', page)
      var para = {}
      para.method = 'shop.couponpage'
      para.page = page
      para.num = 15
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        that.$set(that.cpPage, 'total', ret.body.data.count)
        that.cpList = ret.body.data.data
      })
    },
    loadCouponType: function () {
      var that = this
      var para = {}
      para.method = 'shop.getcouponList'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.couponType = ret.body.data
        var temp = ret.body.data
        temp.forEach(function (key, value) {
          that.cpTypeRoute[key.ID] = key
        })
      })
    },
    typeChange: function (data) {
      var that = this
      this.currType = this.cpTypeRoute[data].typeCode
      if (this.cpTypeRoute[data].typeCode === 'spu' || this.cpTypeRoute[data].typeCode === 'sku') {
        that.$set(that.addData, 'isGlobal', 'f')
      } else {
        that.$set(that.addData, 'isGlobal', 't')
      }
    },
    getStart: function (data) {
      alert(data)
      var that = this
      this.$set(that.addData, 'startAt', data)
    },
    getEnd: function (data) {
      var that = this
      this.$set(that.addData, 'endAt', data)
    },
    handleNewCoupon: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.addData
          para.method = 'shop.addnewcoupon'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              this.$message.success('新优惠券申请在功!')
              that.loadCoupon(1)
            } else if (ret.body.data.code === 202) {
              this.$alert('优惠券已经存在!')
            } else {
              this.$alert('新优惠券设置失败，请稍后重试!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/market/Coupon.vue